import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreatePeepMap as CreatePeepMapMutation,
    CreatePeepMapVariables,
    PeepMapCreateInput,
} from 'nutshell-graphql-types';

import CREATE_PEEP_MAP from '../mutations/create-peep-map.graphql';

export const useCreatePeepMap = (): {
    createPeepMap: (input: PeepMapCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createPeepMap, {loading, error}] = useMutation<
        CreatePeepMapMutation,
        CreatePeepMapVariables
    >(CREATE_PEEP_MAP);

    return {
        createPeepMap: (input: PeepMapCreateInput) =>
            createPeepMap({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
